import React, { useState } from "react";
import { Formik, Form } from 'formik';
import ButtonForm from "../../../../components/Button/ButtonForm";
import { useAuth } from "../../../../provider";
import axios from 'axios';
import {VACCLIST} from '../../../../constants'
import TextInput from "../../../../components/Forms/TextInput";
import * as Yup from 'yup';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';


export const VaccsInput = () => {

    const { state } = useAuth();

    const [uploading, setUploading] = useState(false);
    const [info, setInfo] = useState();
    const [message, setMessage] = useState();
    const [error, setError] = useState();  


    const handleSubmit = (values) => {

      setUploading(true)
      axios.post(VACCLIST, values)
      .then((response) => {
        setMessage(response);
        setUploading(false)
        setInfo('Upload successful !')
      })
      .catch(function (error) {
        setUploading(false)
        //throw new Error(error)
        setError(error.toJSON());
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          //console.log(error.response.data, error.response.status);
          
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
          //console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          //console.log('Error', error.message);
        }
        //console.log(error.config);
        console.log("Error")
      })


    }

  return (
    <>

    <Formik 

        initialValues={{ vacc_date: '', vacc_type: '', owner: state.user.id}}
        validationSchema={validationAddForm}
        onSubmit={(values, { setSubmitting }) => { 
            handleSubmit(values); 
            setSubmitting(false);  
            }}
        >

      <Grid container sx={{ mt: 4, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

          <Form>  
            <TextInput label="date" name="vacc_date" type="date" placeholder="date" />
            <TextInput label="vacc type" name="vacc_type" type="text" placeholder="vacc type" />
            <ButtonForm name={ 'Submit' } disabled={Formik.isSubmitting} />
          </Form>

      </Grid>


      
    </Formik> 


    {error  ? (
    <Alert severity="error" sx={{mt:2}}>
        <Typography variant="body2"  sx={{fontWeight: '500'}}> {error.message} </Typography>
    </Alert>
    ) : (null)}

    {message  ? (
    <Alert severity="info" icon={<CheckIcon fontSize="inherit" />} sx={{mt:2}}>
        <Typography variant="body2"  sx={{fontWeight: '500'}}> {info} </Typography>
    </Alert>
    ) : (null)}

</>
);
};


const validationAddForm = Yup.object().shape({

  vacc_date: Yup
      .string('pick date')
      .required('Date is required'),
  
  vacc_type: Yup
      .string()
      .required('vacc type is required'),
  
  });
  